import { Component } from "react";
import Footer from "../shared/Footer";
import { withRouting } from "@/components/shared/withRouting";

function getQueryValue(searchParams, key) {
  const value = searchParams.get(key);
  if (!value || value === "undefined" || value === "null") {
    return "";
  }
  return value.trim();
}

class AuthGoogleComplete extends Component {
  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);

    this.props.handleGoogleLoginComplete(
      this.props.navigate,
      getQueryValue(searchParams, "code"),
      getQueryValue(searchParams, "state")
    );
  }

  render() {
    return (
      <div className="h-full w-full flex flex-col overflow-y-auto">
        <div className="block min-[800px]:flex min-[800px]:flex-row flex-auto w-full">
          <div className="flex flex-1 flex-col items-center self-center mx-auto max-lg:mb-[70px] lg:flex lg:flex-col">
            <div className="relative bg-[top_center] bg-[url('../../images/global/replicated-logo-red.svg')] bg-no-repeat bg-[length:350px] w-[586px] h-[180px] mt-[70px] max-lg:static max-lg:bg-[length:250px] max-lg:w-full max-lg:h-[100px] max-lg:!h-[60px]"></div>
          </div>

          <div className="bg-page-bg lg:ml-0 lg:text-left flex-1 min-h-0 flex flex-col items-center justify-center pb-3 auth-pages">
            <p className="font-['Montserrat',sans-serif] font-bold text-hex-2e96c2 text-[30px] !text-left max-lg:mt-[70px] leading-[1.4] pl-10">
              Completing login...
            </p>
            <div className="w-full max-w-[400px] mx-auto max-[430px]:w-[90%] lg:mx-0">
              <div className="FormButton-wrapper flex"></div>
            </div>
          </div>
          <div className="absolute bottom-[10px] right-[10px] !text-gray-200 max-lg:mx-auto max-lg:pt-[10px] max-lg:static max-lg:w-full max-lg:text-center max-lg:min-h-[100px]">
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouting(AuthGoogleComplete);
